<div
  class="flex items-center justify-between px-6 py-4 border-b border-gray-100"
>
  <h2 class="text-xl font-bold text-gray-800 m-0">Role Details</h2>
  <button mat-icon-button (click)="onCancelClick()" class="text-gray-400">
    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
  </button>
</div>

<div mat-dialog-content class="px-8 py-6 custom-modal-content">
  <div class="grid grid-cols-1 gap-y-3 mb-8">
    <div class="flex items-start">
      <span class="w-40 font-semibold text-gray-600">Name :</span
      ><span class="text-gray-800">{{ role.name }}</span>
    </div>
    <div class="flex items-start">
      <span class="w-40 font-semibold text-gray-600">Description :</span
      ><span class="text-gray-800">{{ role.desc }}</span>
    </div>
    <div class="flex items-start">
      <span class="w-40 font-semibold text-gray-600">Department Name :</span
      ><span class="text-gray-800">{{ role.department }}</span>
    </div>
    <div class="flex items-start">
      <span class="w-40 font-semibold text-gray-600">User Type :</span
      ><span class="text-gray-800">{{ role.userRoleType | titlecase }}</span>
    </div>
  </div>

  <div class="border border-gray-200 rounded-xl overflow-hidden bg-white">
    <div
      class="px-5 py-3 border-b border-gray-100 flex justify-between items-center"
    >
      <span class="font-bold text-gray-700">Modular Permissions</span>
      <mat-icon class="text-gray-400">keyboard_arrow_up</mat-icon>
    </div>

    <div class="p-4">
      <div class="grid grid-cols-2 gap-4">
        <div
          *ngFor="let module of functionalPermissionList"
          class="border border-gray-200 rounded-lg overflow-hidden"
        >
          <div
            class="flex items-center justify-between p-3 cursor-pointer hover:bg-gray-50 transition-colors"
            (click)="module.isExpanded = !module.isExpanded"
          >
            <div class="flex items-center">
              <mat-checkbox
                [checked]="hasValidPermissions(module)"
                disabled
                class="custom-checkbox pointer-events-none"
              >
              </mat-checkbox>
              <span class="ml-2 font-medium text-gray-700">{{
                module.label
              }}</span>
            </div>
            <mat-icon
              class="text-gray-400 transition-transform"
              [class.rotate-180]="module.isExpanded"
            >
              keyboard_arrow_down
            </mat-icon>
          </div>

          <div
            *ngIf="module.isExpanded"
            class="p-4 bg-gray-50 border-t border-gray-100"
          >
            <p
              class="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3"
            >
              Functional Permissions
            </p>

            <div class="grid grid-cols-2 gap-x-4 gap-y-3">
  <ng-container *ngFor="let sub of module.subModules">
    <mat-checkbox
      [checked]="sub.permissions[getEnabledAction(sub)]"
      disabled
      class="custom-checkbox no-label-transform">
      <span class="text-sm text-gray-600 font-medium">{{ getDisplayPermissionName(sub.name) }}</span>
    </mat-checkbox>
  </ng-container>
</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions align="end" class="px-6 py-4 border-t border-gray-50">
    <button
      mat-flat-button
      class="px-10 py-2 rounded-full border border-gray-300 bg-white text-gray-700 font-semibold"
      (click)="onCancelClick()"
    >
      Close
    </button>
  </div>
</div>
